<form [formGroup]="parentForm" class="column-layout">
  <div class="select-field-container">
    <div>County</div>
    <select
      class="form-control border border-primary color w-50 h-28"
      [formControlName]="formCtrlName"
      (change)="change()">
      <option value="">Select County</option>
      <option *ngFor="let county of topORCounties" [value]="county">{{ county }}</option>
      <optgroup label="──────────"></optgroup>
      <option *ngFor="let county of otherORCounties" [value]="county">{{ county }}</option>
    </select>
  </div>
</form>
